import { createAction, props } from "@ngrx/store";

export const resetStore = createAction("[Usuario Component] logOut");
